var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('div',{staticClass:"box-wrap"},[_c('div',{staticClass:"logo",style:({
        backgroundImage: ("url(" + (_vm.detailData.cover) + ")"),
      })}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.detailData.name))])]),_c('div',{staticClass:"return-page",on:{"click":_vm.returnPage}},[_vm._v("返 回")])])}
var staticRenderFns = []

export { render, staticRenderFns }